import { render, staticRenderFns } from "./NewsInformation.vue?vue&type=template&id=944e0d94&scoped=true"
import script from "./NewsInformation.vue?vue&type=script&lang=js"
export * from "./NewsInformation.vue?vue&type=script&lang=js"
import style0 from "./NewsInformation.vue?vue&type=style&index=0&id=944e0d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e0d94",
  null
  
)

export default component.exports